import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { compose } from "recompose";
import { withStyles, Paper, Typography, Table, TableBody, TableHead, TableCell, TableRow } from "@material-ui/core";
import t from "../../../languages/pl";
import ReportRow from "../../CarComponents/Table/CarDetails/NotificationsAndAlerts/ReportRow";
import guid from './../../../utils/guid';
import withSaveButton from './../../HOC/withSaveButton';
import {
    unauthorizedEngineEngageNotification,
    zoningNotification,
    poolZoningNotification,
    disconnectionNotification,
    fuelDrainNotification,
    layoverNotification,
    deviceShiftNotification,
    overSpeedLimitNotification,
    fuelReserve,
    borderCrossed
} from "../../../utils/staticData";
import { notArrayOrEmpty } from '../../../utils/helpers';

const useStyles = theme => ({
    paper: {
        margin: theme.spacing(1),
        padding: theme.spacing(2),
        maxHeight: 560,
    },
    cell: {
        border: 0,
        padding: 0,
        textAlign: "center"
    },
    content: {
        marginLeft: theme.spacing(2)
    }
});

const options = [
    {displayName: t.aboutUnauthorizedEngineEngage, name: unauthorizedEngineEngageNotification},
    {displayName: t.aboutLongDisconnections, name: disconnectionNotification},
    {displayName: t.aboutZoneCrossing, name: zoningNotification},
    {displayName: t.aboutPoolZoneCrossing, name: poolZoningNotification},
    {displayName: t.aboutFuelDrain, name: fuelDrainNotification},
    {displayName: t.aboutSpeedOverLimit, name: overSpeedLimitNotification},
    {displayName: t.aboutLongLayovers, name: layoverNotification},
    {displayName: t.aboutDeviceSwitchToAnotherCar, name: deviceShiftNotification},
    {displayName: t.aboutFuelReserve, name: fuelReserve},
    {displayName: t.aboutCrossingPolishBorder, name: borderCrossed},
];

const Notifications = props => {
    const { classes, data, onChange } = props;
    const [internalState, setInternalState] = useState(data);

    useEffect(() => {
        setInternalState(data);
        props.onFormDataChange(data);
    }, [data]);

    useEffect(() => {
        props.onFormDataChange(internalState);
        onChange && onChange(internalState);
    }, [internalState]);

    const handleCheckboxChange = (name, attrName) => {
        setInternalState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                [attrName]: !prevState[name][attrName]
            }
        }));
    };

    const printOptions = (values) => {
        if(notArrayOrEmpty(Object.keys(values)))
            return;
        return options.map(option => (
            <ReportRow
                key={guid()}
                displayName={option.displayName}
                name={option.name}
                alignCenter
                default={values[option.name].email}
                private={values[option.name].telefon}
                onPrivateChange={(name) => handleCheckboxChange(name, "telefon")}
                onDefaultChange={(name) => handleCheckboxChange(name, "email")}
            />
        ));
    };

    return (
        <Paper
            square
            className={classes.paper}
        >
            <Typography variant="subtitle1">
                {t.notifications}
            </Typography>
            <Table className={classes.content}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.cell} />
                        <TableCell className={classes.cell}>
                            {t.phone}
                        </TableCell>
                        <TableCell className={classes.cell}>
                            {t.email}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {printOptions(internalState)}
                </TableBody>
            </Table>
        </Paper>
    );
};

const mapStateToProps = state => ({
    data: state.settingsReducer.notifications
});

Notifications.propTypes = {
    classes: PropTypes.object,
    onChange: PropTypes.func,
    //redux
    data: PropTypes.object,
    //withSaveButton
    onFormDataChange: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    connect(
        mapStateToProps
    ),
    withSaveButton
)(Notifications);
